import { Tag } from '@zillow/constellation-10';

import { css } from '@/styled-system/css';
import { shimmerStyles } from '../styles/ShimmerStyles';

import type { TagPropsInterface } from '@zillow/constellation-10';

export const LoadingTag = ({
  isLoading,
  loadingWidth,
  children,
  css: cssProp,
  style: styleProp,
  icon,
  ...rest
}: {
  isLoading: boolean;
  loadingWidth: string;
} & TagPropsInterface) => (
  <Tag
    data-loading={isLoading || null}
    css={css.raw(cssProp, shimmerStyles)}
    style={isLoading ? { width: loadingWidth, ...styleProp } : { ...styleProp }}
    icon={isLoading ? null : icon}
    {...rest}
  >
    {isLoading ? <>&nbsp;</> : children}
  </Tag>
);
